export const daikon = {
  contract: {
    network: "Polygon",
    token: "MATIC",
    name: "niftybasemerkle",
    address: "0x0895b39d2b4126d2e7b4dc35e5457578292388a5",
    whitelist: "whitelist2",
  },
  images: [
    {
      title: "sushia",
      image: "/images/content/sushi/daikon/daikon.png",
      image2x: "/images/content/sushi/daikon/daikon.png",
    },
    {
      title: "sushib",
      image: "/images/content/sushi/daikon/daikon.png",
      image2x: "/images/content/sushi/daikon/daikon.png",
    },
    {
      title: "sushic",
      image: "/images/content/sushi/daikon/daikon.png",
      image2x: "/images/content/sushi/daikon/daikon.png",
    },
    {
      title: "sushid",
      image: "/images/content/sushi/daikon/daikon.png",
      image2x: "/images/content/sushi/daikon/daikon.png",
    },
  ],
  activations: {
    title: "Free Mint: Daikon",
    head: "",
    items: [
      {
        title: "Free Mint on Polygon",
        description: [
          "• Free Mint of Daikon Trippy Sushi Character",
          "• Network: Polygon, Must Have MATIC Token",
          "• Only for Trippy Sushi Whitelist",
        ],
        date: "2 days ago",
        image: "/images/content/100p.png",
        icon: "/images/content/download.svg",
        color: "#141416",
      },
    ],
  },
  content: {
    name: "Mystic Daikon Fairy",
    sale: "Free mint now and forever",
    storyline:
      "The TRIPPY SUSHI DAIKON is a rarely seen creature of the deep dark forest. Only the whitelisted can befriend them.",
  },
  heroImage: {
    image: "/images/content/sushi/daikon/daikon.png",
    image2x: "/images/content/sushi/daikon/daikon.png",
  },
  users: [
    {
      name: "Sushi Master",
      position: "Owner",
      avatar: "/images/content/sushi/default-sushi.png",
    },
    {
      name: "Sushi Itamae",
      position: "Developer",
      avatar: "/images/content/sushi/default-sushi.png",
    },
  ],
  discord: {
    title: "Join the Discord. Get Trippy for the drop.",
  },
  socials: [
    {
      title: "twitter",
      url: "https://twitter.com/trippysushi",
    },
    {
      title: "discord",
      url: "https://discord.com/invite/trippysushi",
    },
    {
      title: "polygonscan",
      url: "https://polygonscan.com/address/0x0895B39D2b4126d2e7b4dC35E5457578292388a5",
    },
  ],
  faq: {
    content: {
      faqhead: "learn more about sushi",
      faqdescription: "FAQ",
      cco: "Public Domain CC0",
      faqdomain:
        "To the extent possible under law, Sushi Creators have waived all copyright and related or neighboring rights to Trippy Sushi's. This work is published from:United States.",
    },
    items: [
      {
        title: "General",
        icon: "home",
        items: [
          {
            title: "🧄 Wat Daikon?!",
            description:
              "The TRIPPY SUSHI DAIKON is a rarely seen creature of the deep dark forest. Only the whitelisted can befriend them.",
          },
          {
            title: "⏰ Wen Mint?!",
            description: "Now and Forever",
          },
          {
            title: "💰 How Much Mint?!",
            description: "Free to Mint",
          },
          {
            title: "🗺 Wat Network?!",
            description: "Polygon",
          },
        ],
      },
    ],
  },
};
